module.exports = __webpack_public_path__ + "img/grand-osasis-cancun-room.cc13f33d.jpg";